import heMessages from '../locales/he_IL';

const HeLang = {
  messages: {
    ...heMessages,
  },
  locale: 'he-IL',
};
export default HeLang;
